import { type MutationHookOptions, useMutation } from "@apollo/client";
import { StopEntrypointPullMutation } from "../graphql/mutations";
import type {
  StopEntrypointPullMutationType,
  StopEntrypointPullMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useStopEntrypointPullMutation = (
  options?: MutationHookOptions<
    StopEntrypointPullMutationType,
    StopEntrypointPullMutationVariablesType
  >
) => {
  return useMutation<
    StopEntrypointPullMutationType,
    StopEntrypointPullMutationVariablesType
  >(StopEntrypointPullMutation, options);
};
